import React, { createContext, useContext } from 'react';
import { ConsiderationAutosave } from './useConsiderationAutosave';

const ConsiderationAutosaveQueueContext = createContext<ConsiderationAutosave | null>(null);

const NOOP_QUEUE: ConsiderationAutosave = {
    isRowDirty: () => false,
    pendingFieldValue: () => undefined,
    setFieldValue: () => {},
    pendingComment: () => undefined,
    setComment: () => {},
    flushRowForRemoval: async () => null,
    flush: () => {},
};

export const ConsiderationAutosaveQueueProvider = ({
    queue,
    children,
}: {
    queue: ConsiderationAutosave;
    children: React.ReactNode;
}) => (
    <ConsiderationAutosaveQueueContext.Provider value={queue}>
        {children}
    </ConsiderationAutosaveQueueContext.Provider>
);

export const useConsiderationAutosaveQueue = (): ConsiderationAutosave =>
    useContext(ConsiderationAutosaveQueueContext) ?? NOOP_QUEUE;
